import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController,Events,MenuController,Platform,LoadingController } from 'ionic-angular';

import {Webservice} from '../../providers/webservice'
import {Commontask} from '../../providers/commontask'
import {Storagehelper} from '../../providers/storagehelper'
import {Filetransfer} from '../../providers/filetransfer'
declare var document:any;
import { SocialSharing } from '@ionic-native/social-sharing';
/**
 * Generated class for the Newquestion page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-newquestion',
  templateUrl: 'newquestion.html',
})
export class Newquestion extends Commontask {
  public bckclass;
	public question;
  public localImageFile;
  public loading;
  constructor(public navCtrl: NavController, public navParams: NavParams,public webservice:Webservice,public alertCtrl:AlertController,public events:Events,public menuctrl:MenuController,public platform:Platform,public socialShare:SocialSharing,public loader:LoadingController,public storage:Storagehelper,public filetransfer:Filetransfer) {
  	super(menuctrl,events,platform,socialShare,alertCtrl);
    this.question={ qtext:'' };

    this.loading=this.loader.create({
      spinner:"ios",
      cssClass:"dreamLoader"
    });
    this.changeBackground();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad Newquestion');
  }
  
  ionViewWillEnter(){
    
    this.event.publish('app:changeHeaderBackground'); 
  }


  changeBackground(){
    this.storage.queryStorage("staticTexts","textid",2).then((data)=>{
      if(data!=null){
        var filteredData=data.filter((e,i)=>{
          return e['textid']==2;
        })
        if(data.length>0){
          var newbck=filteredData[0]['background'][0]['image'];
          var localCheck=this.checkIfBackgroundStatic(newbck);
             if(localCheck!=false){
               // this.pageDetail.localImageFile=localurl;
               //Using javascript to set page background
               // document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('../assets/images/"+localCheck+".png')"
               this.bckclass=localCheck;
             }else{

               this.filetransfer.saveFileLocally(newbck,"images").then((localurl)=>{
                 this.localImageFile=localurl;
                 //Using javascript to set page background
                 document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.localImageFile+"')"
               
               },(err)=>{
                this.loading.dismiss();
                 if(err=="browser"){
                   this.localImageFile = newbck;
                   //Using javascript to set page background
                   document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.localImageFile+"')"
                 }
               });
             }
        }
      }
    })
  }


  saveQuestion(){
    var newq={ qtext:this.question.qtext };
    newq.qtext=this.replaceAll(newq.qtext,' ','9a1');
    this.loading.present();
  	this.webservice.saveQuestion(newq).subscribe((data)=>{

  		  
        this.loading.dismiss();
	  		let alert=this.alertCtrl.create({
	  			title:"Mitt lugn",
	  			message:"Skickat",
	  			buttons:[{
	  				text:'OK',
	  				role:'cancel',
	  				handler:()=>{
	  					 this.events.publish("app:goBack");
	  				}
	  			}]
	  		})
	  		alert.present();

	  
  	},
  	err=>{

	  
  	});


  }

  replaceAll(string,search, replacement){
		var target = string;
    	return target.replace(new RegExp(search, 'g'), replacement);
  }
}



// WEBPACK FOOTER //
// ./src/pages/newquestion/newquestion.ts